import React from 'react';
import cx from 'classnames';
import styles from './StatusBadge.module.scss';

import { ProcessIcon, QueuedIcon, FailedIcon } from '../../../assets';
import { IStatusBadgeProps } from '../../../types';
import { StatusDisplay } from '../../../constants';
const STATUS_ICON_MAP: Record<string, React.ReactNode> = {
	PENDING: <ProcessIcon />,
	PROCESSING: <ProcessIcon />,
	QUEUED: <QueuedIcon />,
	ERRORED: <FailedIcon />,
	FAILED: <FailedIcon />,
};

const StatusBadge = ({
	status,
	isPaymentStatus = false,
}: IStatusBadgeProps) => {
	const renderStatus = <span>{StatusDisplay[status]}</span>;
	const icon = STATUS_ICON_MAP[status] || null;

	return (
		<div className={cx(styles.statusBadge, styles[status.toLocaleLowerCase()])}>
			{!isPaymentStatus ? icon : null}
			{renderStatus}
		</div>
	);
};

export default StatusBadge;
